const PayRollConciliationActionStatus =
{
    Processing: 1,
    Finished: 2,
}
export default PayRollConciliationActionStatus;